export class StopDistributionReasonDto {
    public distributionId: string;
    public reasonToStop: string;

    constructor(distributionId: string, reasonToStop: string) {
        this.distributionId = distributionId;
        this.reasonToStop = reasonToStop;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/stop-distribution-reason-dto.ts